module.exports = __webpack_public_path__ + "img/jquerylogo.7c855d7d.png";